import styled, { css } from 'styled-components'

export const BarrierCardContainer = styled.div`
  width: 300px;
  min-width: 300px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.foregroundPaper};
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 12px 4px 12px;
`

export const CardBody = styled.div`
  padding: 4px 12px 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.span`
  flex: 1;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.3;
`

export const Label = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.info};
  min-width: 70px;
`

export const Value = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const CardFooter = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.text};
  `};
  width: 100%;
  padding: 10px 12px 12px 12px;
  border: none;
  cursor: pointer;
  background: none;
  min-height: 44px;
`

export const ViewCommentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const ViewCommentsLink = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textLink};
`

export const SeparatorContainer = styled.div`
  padding: 0 12px;
`
